module.exports = __webpack_public_path__ + "img/tx-station-white.65dfd87a.png";